// Global vars are bad, but this saves us many trips to the server just to fetch the company logo URL
const globalVars = {
  companyLogoUrl: null
}

export default globalVars
